<template>
  <v-data-table :headers="headers" :items="items" class="elevation-1">
    <template v-slot:item="{ item }">
      <slot :item="item"></slot>
    </template>
  </v-data-table>
</template>
<script>
import { IndexData } from "@/helpers/apiMethods";
import createTableHeaders from "@/helpers/TableHeaders";

export default {
  props: {
    headerList: {
      type: Array
    },
    modelRequest: {
      type: Object
    }
  },
  data() {
    return {
      items: [],
      headers: []
    };
  },
  created() {
    this.getData();
    this.createTableHeaders();
  },
  methods: {
    async getData() {
      try {
        const data = await IndexData(this.modelRequest);
        this.items = data.data;
      } catch (error) {
        console.log(error);
      }
    },
    createTableHeaders() {
      this.headers = createTableHeaders(this.headerList);
    }
  }
};
</script>

<style lang="scss" scoped></style>
